/** Hostnames allowed for `next/image` remote loading (keep in sync with next.config). */
export const IMAGE_REMOTE_HOSTS = [
  "firebasestorage.googleapis.com",
  "storage.googleapis.com",
  "lh3.googleusercontent.com",
  "beta.kovaad.ai",
  "chat.kovaad.ai",
  "test.kovaad.ai",
] as const;

const isFirebaseStorageAppHost = (hostname: string): boolean =>
  hostname === "firebasestorage.app" ||
  hostname.endsWith(".firebasestorage.app");

/** Absolute http(s) URLs — load with <img>, not next/image (avoids /_next/image 400 on deployed hosts). */
export function isRemoteImageUrl(src: string): boolean {
  if (
    !src ||
    src.startsWith("/") ||
    src.startsWith("data:") ||
    src.startsWith("blob:")
  ) {
    return false;
  }

  try {
    const url = new URL(src);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function isNextImageAllowedHost(src: string): boolean {
  if (!src || src.startsWith("/") || src.startsWith("data:")) {
    return true;
  }

  try {
    const url = new URL(src);
    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return false;
    }
    if (isFirebaseStorageAppHost(url.hostname)) {
      return true;
    }
    return IMAGE_REMOTE_HOSTS.includes(
      url.hostname as (typeof IMAGE_REMOTE_HOSTS)[number],
    );
  } catch {
    return true;
  }
}

export const imageRemotePatterns = [
  ...IMAGE_REMOTE_HOSTS.map((hostname) => ({
    protocol: "https" as const,
    hostname,
    port: "",
    pathname: "/**",
  })),
  {
    protocol: "https" as const,
    hostname: "**.firebasestorage.app",
    port: "",
    pathname: "/**",
  },
];
